import { createAction, props } from '@ngrx/store';

export const setCountryCode = createAction(
   '[Global] Set Country Code',
   props<{ countryCode: string }>()
);

export const setCountryCodeResolutionPending = createAction(
   '[Global] Set Country Code Resolution Pending'
);

export const setCountryCodeResolutionComplete = createAction(
   '[Global] Set Country Code Resolution Complete'
);
